export default __webpack_public_path__ + "static/media/message-card.aa6f4a8f.png";